module.exports = __webpack_public_path__ + "static/media/opt-icon-active.ff593f58.svg";